import { render, staticRenderFns } from "./BroadcastMessageTest.vue?vue&type=template&id=24f9c9e6&scoped=true&"
import script from "./BroadcastMessageTest.vue?vue&type=script&lang=ts&"
export * from "./BroadcastMessageTest.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastMessageTest.vue?vue&type=style&index=0&id=24f9c9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f9c9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VTextField,VTooltip})
